// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Utils = require("../../utils/Utils.bs.js");
var Tooltip = require("../../reason/common/Tooltip.bs.js");
var Icon__Jsx3 = require("../../uikit/reason/atoms/Icon/Icon__Jsx3.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var Theme__Color__Vars = require("../../reason/common/Theme/Theme__Color__Vars.bs.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var AreasCriteria_area_graphql = require("../../__generated__/AreasCriteria_area_graphql.bs.js");

var convertFragment = AreasCriteria_area_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, AreasCriteria_area_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(AreasCriteria_area_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(fRef) : undefined, AreasCriteria_area_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(AreasCriteria_area_graphql.node, convertFragment, fRef);
}

var Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function AreasCriteria(props) {
  var __icon = props.icon;
  var icon = __icon !== undefined ? Caml_option.valFromOption(__icon) : "Location";
  var areas = use(props.areas);
  return JsxRuntime.jsxs("div", {
              children: [
                Core__Option.getOr(Core__Option.map(icon, (function (icon) {
                            return JsxRuntime.jsx(Icon__Jsx3.make, {
                                        icon: icon,
                                        color: Theme__Color__Vars.silver
                                      });
                          })), null),
                JsxRuntime.jsx("div", {
                      children: (function (__x) {
                            return Utils.$$Array.pseudoJoin(", ", undefined, __x);
                          })(areas.map(function (area) {
                                return JsxRuntime.jsx(Tooltip.make, {
                                            label: area.label,
                                            children: JsxRuntime.jsx("span", {
                                                  children: area.name,
                                                  className: "md:inline-block md:underline md:decoration-dotted md:decoration-zinc-400"
                                                })
                                          });
                              })),
                      className: "text-zinc-700"
                    })
              ],
              className: "flex items-start gap-2"
            });
}

var make = AreasCriteria;

exports.Fragment = Fragment;
exports.make = make;
/* Utils Not a pure module */
